import React, { useEffect, useState } from "react";

import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import BlockUi from "react-block-ui";
import { useSubheader } from "../../layout/_core/MetronicSubheader";
import ModalViewOpportunity from "../../../app/components/ModalViewOpportunity";

export function UserDashboard() {
  const dashboard = useSelector(state => state.app.dashboard);
  const is_dashboard_loading = useSelector(
    state => state.app.is_dashboard_loading
  );
  const { user } = useSelector(state => state.auth);
  const subheader = useSubheader();
  const [opportunity, setOpportunity] = useState({});

  const dispatch = useDispatch();
  const [isModalViewOpportunityOpen, setIsModalViewOpportunityOpen] = useState(
    false
  );

  useEffect(() => {
    dispatch({ type: "LOAD_DASHBOARD" });
    subheader.setBreadcrumbs([]);
  }, []);

  return (
    <div className="user-dashboard">
      <ModalViewOpportunity
        opportunity={opportunity}
        isOpen={isModalViewOpportunityOpen}
        close={() => setIsModalViewOpportunityOpen(false)}
      />

      <div className="row">
        <div className="col-xxl-12 mb-10">
          <h1 className="azul-cabecalho">
            Seja bem-vindo, {user.name.split(" ")[0]}
          </h1>
        </div>
      </div>
      <BlockUi tag="div" blocking={is_dashboard_loading}>
        <div className="row">
          <div className="col-xl-12">
            <div className="row">
              <div className="col-xl-6 column-custom ">
                <div
                  className={
                    "card card-custom card-stretch card-numeric gutter-b"
                  }
                  style={{ backgroundColor: "#091D5C" }}
                >
                  <div className="card-body p-0">
                    <div className="d-flex flex-column">
                      <span className="card-visualizar">
                        <Link to="/clientes" style={{ color: "#FFF" }}>
                          VISUALIZAR
                        </Link>
                      </span>
                      <span className="card-descricao">CLIENTES</span>
                      <span className="card-numero">{dashboard.customers}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 column-custom">
                <div
                  className={
                    "card card-custom card-numeric card-stretch gutter-b"
                  }
                  style={{ backgroundColor: "#0B236E" }}
                >
                  <div className="card-body p-0">
                    <div className="d-flex flex-column">
                      <span className="card-visualizar">
                        <Link to="/clientes" style={{ color: "#fff" }}>
                          VISUALIZAR
                        </Link>
                      </span>
                      <span className="card-descricao">CADASTROS HOJE</span>
                      <span className="card-numero">
                        {dashboard.registers_today}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {dashboard.paid && (
                <div className="col-xl-6 column-custom">
                  <div
                    className={
                      "card card-custom card-numeric card-stretch gutter-b"
                    }
                    style={{ backgroundColor: "#1640C6" }}
                  >
                    <div className="card-body p-0">
                      <div className="d-flex flex-column">
                        <span className="card-visualizar">
                          <a
                            href="https://dashboard.pagar.me/"
                            target="_BLANK"
                            style={{ color: "#FFF" }}
                            rel="noreferrer"
                          >
                            VISUALIZAR
                          </a>
                        </span>
                        <span className="card-descricao">CLIENTES EM DIA</span>
                        <span className="card-numero">{dashboard.paid}</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {dashboard.active && (
                <div className="col-xl-6 column-custom">
                  <div
                    className={
                      "card card-custom card-numeric card-stretch gutter-b"
                    }
                    style={{ backgroundColor: "#1640C6" }}
                  >
                    <div className="card-body p-0">
                      <div className="d-flex flex-column">
                        <span className="card-visualizar">
                          <a
                            href="https://dashboard.pagar.me/"
                            target="_BLANK"
                            style={{ color: "#FFF" }}
                            rel="noreferrer"
                          >
                            VISUALIZAR
                          </a>
                        </span>
                        <span className="card-descricao">CLIENTES ATIVOS</span>
                        <span className="card-numero">{dashboard.active}</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="col-xl-6 column-custom">
                <div
                  className={
                    "card card-custom card-numeric card-stretch gutter-b"
                  }
                  style={{ backgroundColor: "#f64e60" }}
                >
                  <div className="card-body p-0">
                    <div className="d-flex flex-column">
                      <span className="card-visualizar">
                        <Link
                          to="/cancelados/clientes"
                          style={{ color: "#fff" }}
                        >
                          VISUALIZAR
                        </Link>
                      </span>
                      <span className="card-descricao">
                        CANCELAMENTOS DE CLIENTES HOJE
                      </span>
                      <span className="card-numero">{dashboard.canceled}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-6 column-custom">
                <div
                  className={
                    "card card-custom card-numeric card-stretch gutter-b"
                  }
                  style={{ backgroundColor: "#f64e60" }}
                >
                  <div className="card-body p-0">
                    <div className="d-flex flex-column">
                      <span className="card-visualizar">
                        <Link
                          to="/cancelados/recente"
                          style={{ color: "#fff" }}
                        >
                          VISUALIZAR
                        </Link>
                      </span>
                      <span className="card-descricao">
                        CANCELAMENTOS PAGOU 1x
                      </span>
                      <span className="card-numero">
                        {dashboard.canceled_recent}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BlockUi>
    </div>
  );
}
